import React, { useEffect, useRef, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faDollarSign,
  faUser,
  faStore,
  faWeightHanging
} from '@fortawesome/free-solid-svg-icons';
import { flushSync } from 'react-dom';

import FaturamentoRelatorio from '../../pedido-faturamento-relatorio';
import FaturamentoCategorias from '../../faturamento-categorias';
import TopClientes from '../../top-clientes';
import RankingVendedores from '../../ranking-vendedores';
import RankingVendedoresVolume from '../../ranking-vendedores-volume';
import AcoesLojas from '../../acoes-lojas';

import DashboardService from 'services/dashboard-service';
import ProdutoService from 'services/produto-service';
import PedidoService from 'services/pedido-service';

import './styles.scss';
import RedeService from 'services/rede-service';

const Dashboard = () => {
  const data = new Date();

  const refFilter = useRef({});
  const [filter, setFilter] = useState({
    representada: null,
    redes: [],
    ano: data.getFullYear(),
    mes: data.getMonth() + 1
  });

  const [redes, setRedes] = useState();
  const [representadas, setRepresentadas] = useState([]);
  const [vendedores, setVendedores] = React.useState([]);
  const [lojas, setLojas] = React.useState();

  const [metaContratante, setMetaContratante] = useState({});
  const [clientesAtivos, setClientesAtivos] = useState([]);

  const [metaEquipe, setMetaEquipe] = useState(null);
  const [faturamentoEquipe, setFaturamentoEquipe] = useState([]);
  const [erroFaturamento, setErroFaturamento] = useState([]);

  const [loadingOnSearch, setLoadingOnSearch] = useState(false);

  useEffect(async () => {
    const firstRepresentada = await getSelectListRepresentada();

    await getSelectListRede();
    await getSelectListVendedor();
    await getSelectListLoja();

    if (firstRepresentada) {
      flushSync(() => {
        setFilter({ ...filter, representada: firstRepresentada });
      });
    }
  }, []);

  async function getSelectListRepresentada() {
    let representadas = await ProdutoService.selectListRepresentadasAsync();

    if (representadas.data) {
      setRepresentadas(representadas.data.data);
      return representadas.data.data[0];
    }
  }

  function getFilterParams(representada) {
    let params = {
      representadaId: representada
        ? representada.value
          ? representada.value
          : representada.representada.value
        : refFilter.current.value,
      mes: filter.mes,
      ano: filter.ano
    };

    return params;
  }

  async function getSelectListRede() {
    const result = await RedeService.getSelectList();
    if (result.data) setRedes(result.data.data);
  }

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();
    if (vendedores.data) setVendedores(vendedores.data.data); //([...[{}], ...representadas.data.data]);
  }

  async function getSelectListLoja() {
    let lojas = await PedidoService.getSelectListLoja();
    if (lojas.data) setLojas(lojas.data.data); //([...[{}], ...lojas.data.data]);
  }

  async function getClientesAtivos(representada) {
    const response = await DashboardService.getClientesAtivosAsync(getFilterParams(representada));

    if (response.data) setClientesAtivos(response.data.data);
  }

  async function getFaturamentoPorEquipe(representada) {
    let response = await DashboardService.getFaturamentoPorEquipeAsync(
      getFilterParams(representada)
    );

    setFaturamentoEquipe(response.data.data);
    if (response.data.errors) {
      flushSync(() => setFaturamentoEquipe([]));
      setErroFaturamento(response.data.errors);
    } else {
      setErroFaturamento([]);
    }
  }

  async function getCardsMensais(representada) {
    let response = await DashboardService.getCardsMensais(getFilterParams(representada));

    response.data && setMetaEquipe(response.data.data);
  }

  async function getRelatorio(representada) {
    refFilter.current = getFilterParams();

    await Promise.all([getSelectListRede()]);
  }

  async function getMetaCotratante() {
    let response = await DashboardService.getMetaContratanteAsync(refFilter.current);

    setMetaContratante(response.data.data);
  }

  async function limpar() {
    setFilter({
      representada: null,
      redes: [],
      ano: data.getFullYear(),
      mes: data.getMonth() + 1
    });
  }

  return (
    <div className="dashboard-page home-dashboard">
      <Tabs defaultActiveKey="NovaHome" id="tabs-relatorio">
        {/* <Tab
          eventKey="Evolução Mensal"
          title={
            <>
              <FontAwesomeIcon icon={faLineChart} />
              Evolução Mensal
            </>
          }
        >
          <>
            <div className="active-tab-name text-secondary">Evolução Mensal</div>
            <Pedidos
              representadas={representadas}
              redes={redes}
              lojas={lojas}
              vendedores={vendedores}
            />
          </>
        </Tab> */}

        {/* <Tab
          eventKey="Vendas e Metas"
          title={
            <>
              <FontAwesomeIcon icon={faUser} />
              Vendas e Metas
            </>
          }
        >
          <>
            <div className="active-tab-name text-secondary">Vendas e Metas</div>
            <Vendas representadas={representadas} />
          </>
        </Tab>

        <Tab
          eventKey="Base de Clientes"
          title={
            <>
              <FontAwesomeIcon icon={faUsers} />
              Base de Clientes
            </>
          }
        >
          <>
            <div className="active-tab-name text-secondary">Base de Clientes</div>
            <Clientes representadas={representadas} />
          </>
        </Tab> */}

        <Tab
          eventKey="NovaHome"
          title={
            <>
              <FontAwesomeIcon icon={faUser} />
              Objetivo
            </>
          }
        >
          <AcoesLojas representadas={representadas} vendedores={vendedores} />
        </Tab>

        {/* <Tab
          eventKey="Faturamento"
          title={
            <>
              <FontAwesomeIcon icon={faUser} />
              Objetivo
            </>
          }
        >
          <FaturamentoCategorias vendedores={vendedores} representadas={representadas} />
        </Tab> */}

        <Tab
          eventKey="Romaneio"
          title={
            <>
              <FontAwesomeIcon icon={faDollarSign} />
              Romaneio
            </>
          }
        >
          <FaturamentoRelatorio lojas={lojas} vendedores={vendedores} />
        </Tab>

        <Tab
          eventKey="Top 30"
          title={
            <>
              <FontAwesomeIcon icon={faStore} />
              Top 30
            </>
          }
        >
          <TopClientes vendedores={vendedores} representadas={representadas} />
        </Tab>

        <Tab
          eventKey="Vendedores Faturamento"
          title={
            <>
              <FontAwesomeIcon icon={faUsers} />
              Faturamento
            </>
          }
        >
          <RankingVendedores representadas={representadas} />
        </Tab>

        <Tab
          eventKey="Vendedores Volume"
          title={
            <>
              <FontAwesomeIcon icon={faWeightHanging} />
              Volume
            </>
          }
        >
          <RankingVendedoresVolume representadas={representadas} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Dashboard;
